import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const ChevronLeftIcon = props => (
  <SvgIcon
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      d={
        `M6.79341988,11.2914944 L15.7898236,2.29347265 C16.1810501,1.90217578 16.8153536,1.90217578 
        17.2065801,2.29347265 C17.5978066,2.68476951 17.5978066,3.31918708 17.2065801,3.71048394 
        L8.91855462,12 L17.2065801,20.2895161 C17.5978066,20.6808129 17.5978066,21.3152305 
        17.2065801,21.7065274 C16.8153536,22.0978242 16.1810501,22.0978242 15.7898236,21.7065274 
        L6.79341988,12.7085056 C6.40219337,12.3172088 6.40219337,11.6827912 6.79341988,11.2914944 Z`
      }
      fill="currentcolor"
      fillRule="nonzero"
    />
  </SvgIcon>
);

export default ChevronLeftIcon;
